<template>
    
<com-item :sortable="true" :subtext="subtext" :first="item.first" :last="item.last" :text="text" :name="item.name" v-on:up="$emit('up', item.id)" v-on:down="$emit('down', item.id)" v-on:edit="$emit('edit', item.id)" v-on:delete="$emit('delete', item.id)" />

</template>

<script>

import mixItem from '@/mixin/item.js'

export default {

    mixins: [mixItem],

    computed: {

        subtext: function() {

            return (this.item.type === this.$constants.price.section) ? this.page.business_profile_prices_edit_type_section : this.item.cost

        }

    }
    
}

</script>